import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi'

export const vuetify = createVuetify({
    components,
    directives,
    theme: {
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: '#0D87EF',
                    'primary-dark': '#363636',
                    'input-border': '#919EAB',
                    'grey-bg-100': '#F6F7F8',
                    'grey-border-400': '#CED4DA',
                    'BW-100': '#F6F7F8',
                    'BW-300': '#DEE2E6',
                    'BW-400': '#CED4DA',
                    'BW-450': '#B2B7BD',
                    'BW-500': '#8D959D',
                    'BW-600': '#6C757D',
                    'BW-700': '#495057',
                    'BW-800': '#363636',
                    'error-text': '#D51A52',
                    'BW-red-5': '#D11635',
                    'BW-red-6': '#B20320',
                    'BW-green-4': '#05A660',
                    'BW-green-5': '#00874C',
                    'BW-yellow-5': '#FFCE31',
                    'BW-yellow-6': '#FF8800',
                    'BW-blue-4': '#0D87EF',
                    'text-yellow-5': '#E9B200',
                }
            }
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
});
